import { useState } from "react"
import { CalendarIcon } from "lucide-react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { Popover, PopoverTrigger, PopoverContent } from "../components/ui/popover"
import { cn } from "../lib/utils"

export function DatePickerRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()
  const [date, setDate] = useState<string>("")

  const placeholder = element.placeholder
    ? String(resolveSymbol(element.placeholder) ?? "")
    : "Select date"

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setDate(value)
    dispatchEvent(element.id, "change", { value })
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className={cn(
            "flex h-9 w-full items-center justify-between rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
            !date && "text-muted-foreground",
            element.className,
          )}
          data-testid={`date-picker-${element.id}`}
        >
          {date || placeholder}
          <CalendarIcon className="h-4 w-4 opacity-50" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3" align="start">
        <input
          type="date"
          id={element.id}
          value={date}
          onChange={handleChange}
          aria-label={element.ariaLabel ?? placeholder}
          className="flex h-9 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        />
      </PopoverContent>
    </Popover>
  )
}
